var billingCtrl = (function () {
  let iuguTokenErrors = {
    number: {
      is_invalid: 'O número do cartão é inválido'
    },
    verification_value: {
      is_invalid: 'Código de segurança inválido'
    },
    first_name: {
      is_invalid: 'Nome inválido'
    },
    last_name: {
      is_invalid: 'Nome inválido'
    },
    expiration: {
      is_invalid: 'Data de vencimento inválida'
    }
  };

  let loadAddress = function (zipcode, scope) {
    jQuery.getJSON(`https://viacep.com.br/ws/${zipcode}/json/`, function (result) {
      scope.card.address = result.logradouro;
      scope.card.district = result.bairro;
      scope.card.state = scope.states.filter(s => result.uf && s.code.toLowerCase() === result.uf.toLowerCase())[0];
      scope.onChangeState(scope.card.state, result.localidade);
      scope.$apply();
    });
  };

  let getDiffDate = function (endDate) {
    let date1 = new Date();
    let date2 = new Date(endDate);
    let differenceInTime = date2.getTime() - date1.getTime();
    let differenceInDays = differenceInTime / (1000 * 3600 * 24);
    return Math.round(differenceInDays);
  };

  return {
    billing: function ($scope, Api, NgTableParams, ReqAndUpload, $q, $translate, $http, $routeParams, formNotify) {
      if ($scope.currentUser.role !== 'ADM') {
        document.location.href = '/';
      }

      Iugu.setAccountID('A0A55CE56C4D47A9B4B3F8D65385F0D7');
      Iugu.setTestMode(false);

      $scope.customer = null;
      $scope.subscription = null;
      $scope.changecard = true;
      $scope.projectUsesLegacyBilling = false;
      $scope.card = {
        country: null,
        state: null,
        city: null
      };

      $scope.countries = [];
      $scope.states = [];
      $scope.cities = [];

      let plansDescriptions = {
        professional: '',
        business: '',
        enterprise: ''
      };

      $translate([
        'BILLING.PLANS_TITLE_1',
        'BILLING.PLANS_TITLE_2',
        'BILLING.PLANS_TITLE_3'
      ]).then((translations) => {
        plansDescriptions.professional = translations['BILLING.PLANS_TITLE_1'];
        plansDescriptions.business = translations['BILLING.PLANS_TITLE_2'];
        plansDescriptions.enterprise = translations['BILLING.PLANS_TITLE_3'];
      });

      let getInfo = function () {
        Api.get('billing/customers/payment-method', function (err, resp) {
          if (!err && resp.response.data) {
            $scope.changecard = false;
            $scope.customer = resp.response.data;
            $scope.customer.data.last_digits = $scope.customer.data.display_number.replace(/\D/g, '')
            $scope.card = {
              id: resp.response.data.id,
              name: resp.response.data.holder_name,
              phone_number: resp.response.data.phone_prefix + resp.response.data.phone_number,
              document: resp.response.data.document_number,
              zipcode: resp.response.data.zip_code,
              district: resp.response.data.address_district,
              address: resp.response.data.address_street,
              street_number: resp.response.data.address_number,
              street_complement: resp.response.data.address_complement,
              country: {_id: resp.response.data.address_country_id},
              state: {_id: resp.response.data.address_state_id},
              city: {_id: resp.response.data.address_city_id}
            }
          }
          $scope.getCountries();
        });

        Api.get('billing/subscriptions/payment-information', function (err, resp) {
          if (!err) {
            $scope.subscription = resp.response.data;
            $scope.subscription.amountValue = $scope.subscription.amount_value / 100;
            $scope.currency = $scope.subscription.amount_currency === 'brl' ? 'R$' : '$';
            $scope.subscription.description = plansDescriptions[$scope.subscription.plan_name];
          } else if (err.response.error_code === 'PROJECT_USES_LEGACY_BILLING') {
            $scope.projectUsesLegacyBilling = true;
          }
        });
      };

      let getSurname = function (full_name) {
        const s = full_name.split(' ');
        s.shift();
        return s.join(' ');
      };

      let getFirstName = function (full_name) {
        return full_name.split(' ')[0];
      };

      $scope.restartSubscription = function () {
        Api.put('billing/subscriptions/reactivation', {}, function (err, resp) {
          if (!err) {
            getInfo();
          }
        });
      };

      $scope.getCountries = function () {
        Api.get('regions/countries', function (err, resp) {
          if (!err) {
            $scope.countries = resp.response.data.sort(function (a, b) {
              return (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0);
            });
            if ($scope.card.country) {
              $scope.card.country = $scope.countries.filter(c => c._id === $scope.card.country._id)[0];
            } else {
              $scope.card.country = $scope.countries.filter(c => c.name === 'Brazil')[0];
            }
            $scope.onChangeCountry($scope.card.country);
          }
        });
      };

      $scope.onChangeCountry = function (country) {
        if (country) {
          Api.get(`regions/subcountries?country_id=${country._id}`, function (err, resp) {
            if (!err) {
              $scope.states = resp.response.data.sort(function (a, b) {
                return (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0);
              });
              if ($scope.card.state) {
                $scope.card.state = $scope.states.filter(c => c._id === $scope.card.state._id)[0];
                $scope.onChangeState($scope.card.state);
              }
            }
          });
        }
      };

      $scope.onChangeState = function (state, city = '') {
        if (state) {
          Api.get(`regions/cities?subcountry_id=${state._id}`, function (err, resp) {
            if (!err) {
              $scope.cities = resp.response.data.sort(function (a, b) {
                return (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0);
              });
              if (city !== '') {
                $scope.card.city = $scope.cities.filter(c => c.name == city)[0];
              } else if ($scope.card.city) {
                $scope.card.city = $scope.cities.filter(c => c._id === $scope.card.city._id)[0];
              }
            }
          });
        }
      };

      let submitFormCard = function (paymentMethod, Form) {
        Api.put('billing/customers/payment-method', paymentMethod, function (err, resp) {
          if (!err) {
            $translate('BILLING.CARD_ADDED').then(function (result) {
              App.toast(result, 3000);
            });
            $scope.card = {};
            Form.$setPristine();
            $('#addcard').closeModal();
            getInfo();
            $scope.syncData();
          } else {
            $translate('BILLING.CARD_ADD_FAIL').then(function (result) {
              App.toast(result, 3000);
            });
          }

          $scope.loading = false;
        });
      };

      $scope.add = function (card, Form) {
        if (Form.$invalid) {
          formNotify($scope, Form);
          return false;
        }
        $scope.loading = true;
        if ($scope.card.id && !$scope.changecard) {
          let paymentMethod = {
            email: $scope.currentUser.email,
            zip_code: card.zipcode,
            address_country_id: card.country._id,
            address_state_id: card.state._id,
            address_city_id: card.city._id,
            address_district: card.district,
            address_street: card.address,
            address_number: card.street_number,
            address_complement: card.street_complement,
          };
          submitFormCard(paymentMethod, Form);
        } else {
          let expires = new Date(card.expires);
          card.exp_month = expires.getMonth() + 1;
          card.exp_year = expires.getFullYear();

          let creditCard = Iugu.CreditCard(
            card.number,
            card.exp_month,
            card.exp_year,
            getFirstName(card.name),
            getSurname(card.name),
            card.cvc);

          Iugu.createPaymentToken(creditCard, function (data) {
            if (data.errors) {
              let erroMsgs = [];
              for (let prop in data.errors) {
                erroMsgs.push(iuguTokenErrors[prop][data.errors[prop]]);
              }
              App.toast(erroMsgs.join('<br>'), 8000);
              $scope.loading = false;
            } else {
              let paymentMethod = {
                name: card.name,
                email: $scope.currentUser.email,
                phone_prefix: card.phone_number.substr(0, 2),
                phone_number: card.phone_number.substr(2),
                document_number: card.document,
                zip_code: card.zipcode,
                address_country_id: card.country._id,
                address_state_id: card.state._id,
                address_city_id: card.city._id,
                address_district: card.district,
                address_street: card.address,
                address_number: card.street_number,
                address_complement: card.street_complement,
                card_token: data.id
              };
              submitFormCard(paymentMethod, Form);
            }
          });
        }
      };

      $scope.card_issuer = 'fa fa-credit-card';
      $scope.$watch('card.number', function () {
        if ($scope.card.number) {
          // Diners
          if ($scope.card.number.toString().match(/^(300|305|36|38)/)) $scope.card_issuer = 'fab fa-cc-diners-club';

          // Amex
          else if ($scope.card.number.toString().match(/^(34|37)/)) $scope.card_issuer = 'fab fa-cc-amex';

          // Visa
          else if ($scope.card.number.toString().match(/^(4)/)) $scope.card_issuer = 'fab fa-cc-visa';

          // Mastercard
          else if ($scope.card.number.toString().match(/^(51|55)/)) $scope.card_issuer = 'fab fa-cc-mastercard';

          // Discover
          else if ($scope.card.number.toString().match(/^(6011)/)) $scope.card_issuer = 'fab fa-cc-discover';

          // JCB
          else if ($scope.card.number.toString().match(/^(3528|3589)/)) $scope.card_issuer = 'fab fa-cc-jcb';

          else $scope.card_issuer = 'fa fa-credit-card';
        }
      });

      $scope.findZipCode = function (country, zipcode) {
        if (typeof (zipcode) === 'undefined' || typeof (country) === 'undefined') {
          return;
        }
        if (country.code !== 'BR') {
          return;
        }
        $scope.loadAddress(zipcode, $scope);
      };

      $scope.loadAddress = loadAddress;

      getInfo();
    },

    invoice: function ($scope, Api, NgTableParams, ReqAndUpload, $q, $translate, $http, $routeParams) {

      if ($scope.currentUser.role !== 'ADM') {
        document.location.href = '/';
      }

      Api.get(`billing/invoices/${$routeParams.id}/receipt`, function (err, resp) {
        if (!err) {
          $scope.invoice = resp.response.data;
          $scope.invoice.amountValue = $scope.invoice.total_amount_due_value / 100;
          $scope.invoice.currency = $scope.invoice.amount_currency === 'brl' ? 'R$' : '$';
        }
      });
    },

    options: function ($scope, Api, NgTableParams, ReqAndUpload, $q, $translate, $http, $routeParams, formNotify) {

      if ($scope.currentUser.role !== 'ADM') {
        document.location.href = '/';
      }

      let getInfo = function () {
        Api.get('billing/subscriptions/payment-information', function (err, resp) {
          if (!err) {
            $scope.subscription = resp.response.data;
          }
        });
      };

      getInfo();

      $scope.cancelSubscription = function (data, Form) {
        if (Form.$invalid) {
          formNotify($scope, Form);
          return false;
        }
        Api.put('billing/subscriptions/cancellation', data, function (resp) {
          getInfo();
          $('#unsubscribe').closeModal();
        });
      }

    },

    changePlan: function ($scope, Api, NgTableParams, ReqAndUpload, $q, $translate, $http, $routeParams, formNotify) {

      if ($scope.currentUser.role !== 'ADM') {
        document.location.href = '/';
      }
      $scope.changecard = false;

      Iugu.setAccountID('A0A55CE56C4D47A9B4B3F8D65385F0D7');
      Iugu.setTestMode(false);

      let getInfo = function () {
        Api.get('billing/customers/payment-method', function (err, resp) {
          if (!err && resp.response.data) {
            $scope.changecard = false;
            $scope.customer = resp.response.data;
            $scope.customer.data.last_digits = $scope.customer.data.display_number.replace(/\D/g, '')
            $scope.card = {
              id: resp.response.data.id,
              name: resp.response.data.holder_name,
              phone_number: resp.response.data.phone_prefix + resp.response.data.phone_number,
              document: resp.response.data.document_number,
              zipcode: resp.response.data.zip_code,
              district: resp.response.data.address_district,
              address: resp.response.data.address_street,
              street_number: resp.response.data.address_number,
              street_complement: resp.response.data.address_complement,
              country: {_id: resp.response.data.address_country_id},
              state: {_id: resp.response.data.address_state_id},
              city: {_id: resp.response.data.address_city_id}
            }
          }
          $scope.getCountries();
        });
      };

      if (localStorage && localStorage.getItem('offer')) {
        $scope.OfferInvoice = JSON.parse(localStorage.getItem('offer'));
        $scope.OfferInvoice.amountValue = $scope.OfferInvoice.amount_value / 100;
        $scope.OfferInvoice.currency = $scope.OfferInvoice.amount_currency === 'brl' ? 'R$' : '$';
      }

      $scope.card = {
        country: null,
        state: null,
        city: null
      };

      $scope.countries = [];
      $scope.states = [];
      $scope.cities = [];

      $scope.getCountries = function () {
        Api.get('regions/countries', function (err, resp) {
          if (!err) {
            $scope.countries = resp.response.data.sort(function (a, b) {
              return (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0);
            });
            if ($scope.card.country) {
              $scope.card.country = $scope.countries.filter(c => c._id === $scope.card.country._id)[0];
            } else {
              $scope.card.country = $scope.countries.filter(c => c.name === 'Brazil')[0];
            }
            $scope.onChangeCountry($scope.card.country);
          }
        });
      };

      $scope.onChangeCountry = function (country) {
        if (country) {
          Api.get(`regions/subcountries?country_id=${country._id}`, function (err, resp) {
            if (!err) {
              $scope.states = resp.response.data.sort(function (a, b) {
                return (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0);
              });
              if ($scope.card.state) {
                $scope.card.state = $scope.states.filter(c => c._id === $scope.card.state._id)[0];
                $scope.onChangeState($scope.card.state);
              }
            }
          });
        }
      };

      $scope.onChangeState = function (state, city = '') {
        if (state) {
          Api.get(`regions/cities?subcountry_id=${state._id}`, function (err, resp) {
            if (!err) {
              $scope.cities = resp.response.data.sort(function (a, b) {
                return (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0);
              });
              if (city !== '') {
                $scope.card.city = $scope.cities.filter(c => c.name == city)[0];
              } else if ($scope.card.city) {
                $scope.card.city = $scope.cities.filter(c => c._id === $scope.card.city._id)[0];
              }
            }
          });
        }
      };

      $scope.findZipCode = function (country, zipcode) {
        if (typeof (zipcode) === 'undefined' || typeof (country) === 'undefined') {
          return;
        }
        if (country.code !== 'BR') {
          return;
        }
        $scope.loadAddress(zipcode, $scope);
      };

      $scope.loadAddress = loadAddress;

      let submitChangePlan = function (paymentMethod) {
        Api.put('project/plan', paymentMethod, function (err, resp) {
          if (!err) {
            $translate('BILLING.PLAN_UPDATE_SUCCESS').then(function (result) {
              App.toast(result, 3000);
            });
            setTimeout(function () {
              window.location.href = '#!/billing/dashboard';
              window.location.reload();
            }, 3000);
          } else {
            $translate('BILLING.PROCESS_FAIL').then(function (result) {
              App.toast(result, 3000);
            });
          }

          $scope.loading = false;
        });
      };

      let getSurname = function (full_name) {
        const s = full_name.split(' ');
        s.shift();
        return s.join(' ');
      };

      let getFirstName = function (full_name) {
        return full_name.split(' ')[0];
      };

      $scope.changePlan = function (card, Form) {
        if (Form.$invalid) {
          formNotify($scope, Form);
          return false;
        }
        $scope.loading = true;
        if ($scope.card.id && !$scope.changecard) {
          let paymentMethod = {
            offer_id: $scope.OfferInvoice.id,
            email: $scope.currentUser.email,
            zip_code: card.zipcode,
            address_country_id: card.country._id,
            address_state_id: card.state._id,
            address_city_id: card.city._id,
            address_district: card.district,
            address_street: card.address,
            address_number: card.street_number,
            address_complement: card.street_complement,
          };
          submitChangePlan(paymentMethod, Form);
        } else {
          let expires = new Date(card.expires);
          card.exp_month = expires.getMonth() + 1;
          card.exp_year = expires.getFullYear();

          let creditCard = Iugu.CreditCard(
            card.number,
            card.exp_month,
            card.exp_year,
            getFirstName(card.name),
            getSurname(card.name),
            card.cvc);

          Iugu.createPaymentToken(creditCard, function (data) {
            if (data.errors) {
              let erroMsgs = [];
              for (let prop in data.errors) {
                erroMsgs.push(iuguTokenErrors[prop][data.errors[prop]]);
              }
              App.toast(erroMsgs.join('<br>'), 8000);
              $scope.loading = false;
            } else {
              let paymentMethod = {
                offer_id: $scope.OfferInvoice.id,
                name: card.name,
                email: $scope.currentUser.email,
                phone_prefix: card.phone_number.substr(0, 2),
                phone_number: card.phone_number.substr(2),
                document_number: card.document,
                zip_code: card.zipcode,
                address_country_id: card.country._id,
                address_state_id: card.state._id,
                address_city_id: card.city._id,
                address_district: card.district,
                address_street: card.address,
                address_number: card.street_number,
                address_complement: card.street_complement,
                card_token: data.id
              };
              submitChangePlan(paymentMethod, Form);
            }
          });
        }
      };

      $scope.card_issuer = 'fa fa-credit-card';
      $scope.$watch('card.number', function () {
        if ($scope.card.number) {
          // Diners
          if ($scope.card.number.toString().match(/^(300|305|36|38)/)) $scope.card_issuer = 'fab fa-cc-diners-club';

          // Amex
          else if ($scope.card.number.toString().match(/^(34|37)/)) $scope.card_issuer = 'fab fa-cc-amex';

          // Visa
          else if ($scope.card.number.toString().match(/^(4)/)) $scope.card_issuer = 'fab fa-cc-visa';

          // Mastercard
          else if ($scope.card.number.toString().match(/^(51|55)/)) $scope.card_issuer = 'fab fa-cc-mastercard';

          // Discover
          else if ($scope.card.number.toString().match(/^(6011)/)) $scope.card_issuer = 'fab fa-cc-discover';

          // JCB
          else if ($scope.card.number.toString().match(/^(3528|3589)/)) $scope.card_issuer = 'fab fa-cc-jcb';

          else $scope.card_issuer = 'fa fa-credit-card';
        }
      });

      getInfo();
    },

    invoices: function ($scope, Api, NgTableParams, ReqAndUpload, $q, $translate) {

      if ($scope.currentUser.role !== 'ADM') {
        document.location.href = '/';
      }

      Api.get('billing/invoices', function (err, resp) {
        if (!err) {
          $scope.invoices = resp.response.data;
        }
      });
    },

    plans: function ($scope, Api, NgTableParams, ReqAndUpload, $q, $translate) {

      if ($scope.currentUser.role !== 'ADM') {
        document.location.href = '/';
      }

      $scope.activeOffer = 'years';

      $scope.switchOffer = function (offer) {
        $scope.activeOffer = offer;
      };

      $scope.plans = {
        professional: {},
        business: {},
        enterprise: {}
      };

      $scope.subscription = {};

      let plansDescriptions = {
        professional: '',
        business: '',
        enterprise: ''
      };

      let featurePlans = {
        courses_feature_enabled: '',
        post_types_feature_enabled: '',
        newsletter_feature_enabled: '',
        own_domain_feature_enabled: '',
        analytics_feature_enabled: '',
        user_list_exportation_feature_enabled: '',
        integrations_feature_enabled: '',
        groups_feature_enabled: '',
        personal_assistance_feature_enabled: ''
      };

      $translate([
        'BILLING.PLANS_TITLE_1',
        'BILLING.PLANS_TITLE_2',
        'BILLING.PLANS_TITLE_3',
        'BILLING.PLANS_LIST_ITEM_1',
        'BILLING.PLANS_LIST_ITEM_2',
        'BILLING.PLANS_LIST_ITEM_3',
        'BILLING.PLANS_LIST_ITEM_4',
        'BILLING.PLANS_LIST_ITEM_5',
        'BILLING.PLANS_LIST_ITEM_6',
        'BILLING.PLANS_LIST_ITEM_7',
        'BILLING.PLANS_LIST_ITEM_8',
        'BILLING.PLANS_LIST_ITEM_9'
      ]).then((translations) => {
        plansDescriptions.professional = translations['BILLING.PLANS_TITLE_1'];
        plansDescriptions.business = translations['BILLING.PLANS_TITLE_2'];
        plansDescriptions.enterprise = translations['BILLING.PLANS_TITLE_3'];
        featurePlans.courses_feature_enabled = translations['BILLING.PLANS_LIST_ITEM_1'];
        featurePlans.post_types_feature_enabled = translations['BILLING.PLANS_LIST_ITEM_2'];
        featurePlans.groups_feature_enabled = translations['BILLING.PLANS_LIST_ITEM_3'];
        featurePlans.analytics_feature_enabled = translations['BILLING.PLANS_LIST_ITEM_4'];
        featurePlans.user_list_exportation_feature_enabled = translations['BILLING.PLANS_LIST_ITEM_5'];
        featurePlans.newsletter_feature_enabled = translations['BILLING.PLANS_LIST_ITEM_6'];
        featurePlans.integrations_feature_enabled = translations['BILLING.PLANS_LIST_ITEM_7'];
        featurePlans.own_domain_feature_enabled = translations['BILLING.PLANS_LIST_ITEM_8'];
        featurePlans.personal_assistance_feature_enabled = translations['BILLING.PLANS_LIST_ITEM_9'];
      });

      Api.get('plans', function (err, resp) {
        if (!err) {
          if (resp.response && resp.response.data) {
            let data = resp.response.data;
            for (let plan in $scope.plans) {
              $scope.plans[plan] = data.find(e => e.plan.name === plan);
              $scope.plans[plan].title = plansDescriptions[plan];
              if ($scope.plans[plan].offers) {
                $scope.plans[plan].offers = {
                  years: $scope.plans[plan].offers.find(o => o.primary && o.interval_count === 1 && o.interval_type === 'years'),
                  months: $scope.plans[plan].offers.find(o => o.primary && o.interval_count === 1 && o.interval_type === 'months')
                };

                for (let offer in $scope.plans[plan].offers) {
                  let value = $scope.plans[plan].offers[offer].amount_value.toString();
                  if (offer === 'years') {
                    value = Math.round($scope.plans[plan].offers[offer].amount_value / 12).toString();
                  }
                  $scope.plans[plan].offers[offer].currency = $scope.plans[plan].offers[offer].amount_currency === 'brl' ? 'R$' : '$';
                  $scope.plans[plan].offers[offer].amount = {
                    value: value.substr(0, value.length - 2),
                    centsValue: value.substr(-2)
                  };
                }

                $scope.plans[plan].features = [];
                for (let feature in featurePlans) {
                  $scope.plans[plan].features.push({
                    name: featurePlans[feature],
                    inactive: !$scope.plans[plan].plan[feature]
                  });
                }
              }
            }
          }
        }
      });

      Api.get('billing/subscriptions/payment-information', function (err, resp) {
        if (!err) {
          $scope.subscription = resp.response.data;
        }
      });

      $scope.changePlan = function (plan) {
        if (localStorage && plan) {
          let offer = $scope.plans[plan].offers[$scope.activeOffer];
          offer.description = $scope.plans[plan].title;
          localStorage.setItem('offer', JSON.stringify(offer));
          document.location.href = `/manage.app#!/billing/plans/${plan}`;
        }
      }
    }
  }
})();
